import './FieldItem.scss';
import { Button, Input, Popconfirm, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { colors } from '../../../theme/colors';
import useAuthStore from '../../../stores/auth.store';
import { useTranslation } from '../../../i18n/i18n';

const { Text } = Typography;

interface FieldItemProps {
  title: string;
  value: string;
  onChange: (val: string) => void;
  onDelete: () => void;
  adminUuid?: string;
}

const FieldItem = ({ title, value, onChange, onDelete, adminUuid }: FieldItemProps) => {
  const { t } = useTranslation('installation-location', {
    keyPrefix: 'installationLocationDetail.installation.summary.otherFields',
  });
  const isSuperAdminOrCompanyAdmin = useAuthStore((state) => state.isSuperAdminOrCompanyAdmin);
  const isAdmin = useAuthStore((state) => state.isAdmin);
  const userUuid = useAuthStore((state) => state.uuid);

  const isAdminLocation = isAdmin && adminUuid === userUuid;
  return (
    <div className={'FieldItem'}>
      <Text type={'secondary'}>{title}</Text>
      <div className={'FieldItem__content'}>
        <Input
          className={'FieldItem__Input'}
          value={value}
          disabled={!(isSuperAdminOrCompanyAdmin || isAdminLocation)}
          onChange={(e) => onChange(e.target.value)}
        />
        {(isSuperAdminOrCompanyAdmin || isAdminLocation) && (
          <Popconfirm
            title={t('delete')}
            description={t('deleteDesc')}
            okText={t('deleteBtn')}
            cancelText={t('cancel')}
            onConfirm={onDelete}
          >
            <Button type={'text'}>
              <DeleteOutlined style={{ color: colors.RED }} />
            </Button>
          </Popconfirm>
        )}
      </div>
    </div>
  );
};

export default FieldItem;
